import React from 'react'
import { NoChartDataIcon } from '../icons/Icons'

import classes from './styles.module.scss'

interface Props {
  text: string
}

const NoChartData: React.FC<Props> = ({ text }) => (
  <div className={classes.container}>
    <NoChartDataIcon />
    <p className={classes.text}>{text}</p>
  </div>
)

export default NoChartData
